import React from 'react';
import {Section} from '../section/Section';
import css from './VRWorldSection.module.scss';

export const VRWorldSection: React.FC<{}> = () => {
  let yourWorld = (
    <a
      className={css.world_card}
      href={'https://forms.gle/z9nsfSGKg7zy18y68'}
      target="_blank"
      rel="noreferrer"
    >
      <img
        className={css.world_card_image}
        alt="Pulsoid Tech Demo World"
        src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/vrchat-worlds/midi-setup-page/your-world.png"
      />
      <div className={css.world_card_title}>Your World Could Go Here</div>
    </a>
  );

  return (
    <Section
      type="vr-world"
      number={5}
      title="Launch VR Chat and use the integration"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '20px',
          flexDirection: 'row',
        }}
      >
        <a
          className={css.world_card}
          href={
            'https://vrchat.com/home/world/wrld_9ea94b3a-6178-4ba8-b29b-1c2208d224d8'
          }
        >
          <img
            className={css.world_card_image}
            alt="Pulsoid Tech Demo World"
            src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/vrchat-worlds/midi-setup-page/pulsoid-tech-demo-world-vrchat.png"
          />
          <div className={css.world_card_title}>Pulsoid Tech Demo World</div>
        </a>
        {yourWorld}
        {yourWorld}
      </div>
    </Section>
  );
};
